import { useMutation } from '@apollo/client';

import useCompanyContext from 'common/hooks/useCompanyContext';
import { InvoicesDocument } from 'common/hooks/useGetInvoicesQuery/invoices.gql';

import { refetchGetClientStatusOverview } from '../../../../Clients/pages/List/components/ListItem/hooks/mutations/useClientStatusOverview';
import { DeleteInvoiceDocument } from './graphql/deleteInvoice.gql';

interface UseDeleteInvoice {
  invoiceId: string;
  clientId: string;
}

const useDeleteInvoice = ({ clientId, invoiceId }: UseDeleteInvoice) => {
  const { companyProfileId } = useCompanyContext();

  if (!companyProfileId) {
    throw new Error('companyProfile is undefined in useDeleteInvoice hook');
  }

  return useMutation(DeleteInvoiceDocument, {
    awaitRefetchQueries: true,
    refetchQueries: [
      refetchGetClientStatusOverview(clientId),
      InvoicesDocument,
    ],
    variables: {
      input: { invoiceId },
    },
  });
};
export default useDeleteInvoice;
